import { render, staticRenderFns } from "./SearchModal.vue?vue&type=template&id=67d91a92&scoped=true"
import script from "./SearchModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SearchModal.vue?vue&type=style&index=0&id=67d91a92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d91a92",
  null
  
)

export default component.exports